import React from "react";
import styled from "styled-components";
import { FieldGroup, InputCopyContent } from "../Input";

// Import Icons
import { ReactComponent as DiscordIcon } from "../../img/icons/social-media/discord.svg";
import { ReactComponent as RedditIcon } from "../../img/icons/social-media/reddit.svg";
import { ReactComponent as FacebookIcon } from "../../img/icons/social-media/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../img/icons/social-media/twitter.svg";

const ShareStream = ({shareURL}) => {
  return (
    <ShareStreamtyle>
      <h4>Share</h4>
      <form>
        <FieldGroup label="Page link">
          <InputCopyContent
            name="shareURL"
            placeholder="Share URL"
            value={shareURL}
            type="url"
            readOnly
          />
        </FieldGroup>
      </form>
      <SocialLoginStyle>
        <button style={{ backgroundColor: "#5046AF" }}>
          <DiscordIcon />
        </button>
        <button style={{ backgroundColor: "#FF5722" }}>
          <RedditIcon />
        </button>
        <button style={{ backgroundColor: "#55B3EF" }}>
          <TwitterIcon />
        </button>
        <button style={{ backgroundColor: "#445DA0" }}>
          <FacebookIcon />
        </button>
      </SocialLoginStyle>
    </ShareStreamtyle>
  );
};
export default ShareStream;

const ShareStreamtyle = styled.div`
  h4 {
    color: ${({ theme }) => theme.color.primaryText};
    margin-bottom: 24px;
  }
`;

const SocialLoginStyle = styled.div`
  text-align: center;
  margin-top: 24px;
  & > span {
    font-size: 10px;
    color: ${({ theme }) => theme.color.lighterText};
    display: block;
    margin-bottom: 15px;
  }
  button {
    width: 58px;
    border-radius: 8px;
    padding: 7px;
    :not(:last-child) {
      margin-right: 15px;
    }
    :hover {
      transform: scale(0.98);
      transition: transform 200ms ease;
    }
  }
`;
